export default function (data) {
  if (!data || !Array.isArray(data)) {
    console.error('key-value-object-mapper: Invalid data provided');
    return;
  }
  let mapping = {};
  data.forEach((item) => {
    mapping[item.key] = item.value;
  });
  return mapping;
}
